import styled, { css } from 'styled-components';

interface IBackdropContainer {
  visible?: boolean;
  alignModal?: 'flex-start' | 'center' | 'flex-end';
}

interface IAlignModal {
  alignModal?: 'flex-start' | 'center' | 'flex-end';
  scrollView?: boolean;
}

export const BackdropContainer = styled.div<IBackdropContainer>`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  z-index: 3;
  background: #1e1e1e45;

  align-items: ${(props) => (props.alignModal ? props.alignModal : 'center')};

  ${(props) =>
    props.visible === false &&
    css`
      display: none;
    `};
`;

export const Container = styled.div<IAlignModal>`
  position: relative;
  max-width: 60rem;
  width: 100%;
  min-height: 25%;
  height: auto;
  border-radius: 1rem;
  box-shadow: 0rem 0.3rem 0.6rem #0000000f;
  background: #fff;
  padding: 1.5rem 0;
  margin: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 5;

  ${(props) =>
    props.alignModal === 'flex-end' &&
    css`
      margin-bottom: -0.7rem;
    `}

  ${(props) =>
    props.scrollView === true &&
    css`
      display: block;
      overflow-y: auto;
      max-height: 75%;
    `}
`;

export const Header = styled.header`
  width: 100%;
  height: 3.6rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-bottom: 1rem;
  border-bottom: 1px solid #a6a6a6;
`;

export const HeaderTitle = styled.h3`
  font-size: 1.8rem;
  color: #0f0f0f;
  letter-spacing: 0.168rem;
  text-transform: uppercase;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 17rem;
  align-items: center;
  justify-content: space-evenly;
`;

export const Text = styled.p`
  font-size: 2rem;
  font-weight: 500;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
`;

export const Input = styled.input`
  border-radius: 50px;
  border: 0.5px solid #707070;
  height: 35px;
  width: 100%;
  padding: 0 1rem;
`;

export const ModalContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  padding: 40px;
  gap: 2rem;
`;

export const Label = styled.label``;
